import { useShallow } from 'zustand/react/shallow'

import { OpenDialogButton } from '@/components/ConsoleDialog/handlers/OpenDialogButton'
import { MediaFeedDelayForm } from '@/components/forms/MediaFeedDelayForm'
import { STORE_STATUS } from '@/constants/store'
import { useOperatorStoreDDE } from '@/stores/operator/operator.dde.store'

type OperatorMediaFeedDelayProps = {
  operatorId: string
}

export const OperatorMediaFeedDelay = ({ operatorId }: OperatorMediaFeedDelayProps) => {
  const { data, fetchData, isLoading } = useOperatorStoreDDE(
    useShallow((state) => ({
      data: state.data,
      fetchData: state.fetchData,
      isLoading: state.status === STORE_STATUS.loading
    }))
  )

  const delay = data?.[0]?.delay || 5

  return (
    <OpenDialogButton
      label="Edit Delay"
      ButtonProps={{
        variant: 'outlined',
        loading: isLoading
      }}
    >
      <MediaFeedDelayForm
        data={{ operatorId }}
        onSubmit={() => fetchData({ operatorId: Number(operatorId) })}
        defaultValues={{ delay }}
      />
    </OpenDialogButton>
  )
}

export default OperatorMediaFeedDelay
